/** Ответ маршрутов вопросов: UUID затронутого вопроса */
export class QuestionUuid {
  uuid: string

  constructor({ uuid }: { uuid: string }) {
    this.uuid = uuid
  }
}
